import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

// Create an axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Remove 'Bearer ' prefix if it exists, then add it back
      const cleanToken = token.replace('Bearer ', '');
      config.headers.Authorization = `Bearer ${cleanToken}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling common errors
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Check if redirect should be skipped (for specific requests)
      const skipRedirect = (error.config as any)?.skipRedirect;
      if (!skipRedirect) {
        // Handle unauthorized access
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api; 